import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCGdQ-vJGU13FaXV2DoLl3oQYIhZ4_AhPM",
    authDomain: "off-the-ground-platform.firebaseapp.com",
    projectId: "off-the-ground-platform",
    storageBucket: "off-the-ground-platform.firebasestorage.app",
    messagingSenderId: "208844435980",
    appId: "1:208844435980:web:5ec72c2b4b40ab5b417429",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
